export const SESSION_STORAGE_KEYS = {
  PENDING_ACTIVITIES: 'PENDING_ACTIVITIES',
  EXTERNAL_SOURCE: 'EXTERNAL_SOURCE',
  QUEST_ID: 'QUEST_ID',
  REDIRECT_LINK: 'REDIRECT_LINK',
  TEACHER_GRADE: 'TEACHER_GRADE',
  TEACHER_ACTIVITY_DEMO: 'TEACHER_ACTIVITY_DEMO',
  GAME_STATE_SEEN: 'GAME_STATE_SENT',
};
